import { render, staticRenderFns } from "./PDK.vue?vue&type=template&id=2e3aa6eb&"
import script from "./PDK.vue?vue&type=script&lang=js&"
export * from "./PDK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports